// Devuelve el último valor válido (> 0) de un campo (p. ej. "peso" o "altura") tomando la visita
// más reciente que lo tenga. Ordena por id descendente (id mayor = visita más nueva). Cada campo se
// resuelve por separado: una visita puede tener peso pero no altura.
export function latestValidMeasure(visitas, field) {
  if (!Array.isArray(visitas)) return null;
  const conDato = visitas
    .filter((v) => Number(v?.[field]) > 0)
    .sort((a, b) => (Number(b?.id) || 0) - (Number(a?.id) || 0));
  return conDato.length ? Number(conDato[0][field]) : null;
}
